




















import { Mixins, Component, Prop, Emit } from 'vue-property-decorator'
import { FromValueType } from '@/components/common/form/types'
import TcwFormItemCommon from '@/components/common/form/mixins/TcwFormItemCommon'
import TcwFormItem from '@/components/common/form/TcwFormItem.vue'

export interface AutoSize {
  minRows: number
  maxRows: number
}

@Component({
  components: { TcwFormItem }
})
export default class TcwFormItemTextarea extends Mixins(TcwFormItemCommon) {
  @Prop({ default: '' })
  private value!: FromValueType

  @Emit()
  private input(_value: FromValueType): void {
    //
  }
}
